export default {
  props: {
    tab: Object
  },

  mounted() {
    this.refresh();
  },

  activated() {
    this.refresh();
  },

  methods: {
    refresh() {
      // override if needed
    },

    /**
     * Re-emits the update-entity event to parent component.
     *
     * @param {Object} tab Tab instance to update.
     * @param {BaseModel} data Entity instance.
     */
    updateEntity(tab, data) {
      this.$emit('update-entity', tab, data);
    },
  }
};
